"use client";
import { useContext } from "react";
import Image from "next/image";
import { useTranslation } from "react-i18next";
import ArrowRight from "@/assets/images/icons/arrow-right.svg";
import arrowRight from "@/assets/images/icons/whiteArrow.svg";
import AventuraAcuatica from "@/assets/images/landing/Aventura-acuatica-Vee.webp";
import AventuraAire from "@/assets/images/landing/Aventura-en-el-aire-Vee.webp";
import AventuraTierra from "@/assets/images/landing/Aventura-en-tierra-Vee.webp";
import Bienestar from "@/assets/images/landing/Bienestar-con-Vee.webp";
import Bodegas from "@/assets/images/landing/Bodegas-Vee.webp";
import Cultura from "@/assets/images/landing/Cultura-Vee.webp";
import Deporte from "@/assets/images/landing/Deporte-Vee.webp";
import Entradas from "@/assets/images/landing/Entradas-Vee.webp";
import Fotografia from "@/assets/images/landing/Fotografia-Vee.webp";
import Gastronomia from "@/assets/images/landing/Gastronomia-Vee.webp";
import Naturaleza from "@/assets/images/landing/Naturaleza-Vee.webp";
import Ocio from "@/assets/images/landing/Ocio-urbano-Vee.webp";
import Talleres from "@/assets/images/landing/Talleres-Vee.webp";
//import Verano from "@/assets/images/landing/Verano-Vee.webp";
import CustomButton from "@/common/customElements/button";
import {
  CircularDiv,
  CustomDiv,
  InlineDiv,
  VerticalCenterDiv,
} from "@/common/divs";
import {
  AlmostBoldText,
  LightTextSpan,
  RegularText,
  SemiBoldText,
} from "@/common/texts";

import SearchContext from "@/context/searchContext/searchContext";
import { useScroll } from "@/hooks/useScroll";
import { SearchContextType } from "@/types/components";
import { PRIMARY_BUTTON_COLOR } from "@/utils/constants";

const Categories: React.FC<{ setOpen: (value: boolean) => void }> = ({
  setOpen,
}) => {
  const { element, scrollBy, showRightArrow, showLeftArrow, SCROLL_WIDTH } =
    useScroll();
  const { t } = useTranslation();
  const { saveCategory } = useContext(SearchContext) as SearchContextType;
  const imInProd =
    process.env.NEXT_PUBLIC_ENVIRONMENT_AS_DEVELOPMENT === "false";
  return (
    <CustomDiv
      className="global-padding"
      paddingY="80px"
      style={{ paddingLeft: "108px", position: "relative" }}
      background="#FFF7E4"
    >
      <InlineDiv style={{ flexWrap: "wrap" }}>
        <AlmostBoldText
          fontSize="46px"
          style={{ maxWidth: "550px", lineHeight: "55px" }}
        >
          {t("landing.explore")}{" "}
          <LightTextSpan color={PRIMARY_BUTTON_COLOR}>
            {t("landing.oportunities")}
          </LightTextSpan>
        </AlmostBoldText>
        <CustomDiv>
          <RegularText fontSize="20px" style={{ maxWidth: "450px" }}>
            {t("landing.oportunities_title")}
          </RegularText>
          <CustomButton
            marginY="7px"
            width="197px"
            height="50px"
            backgroundColor={PRIMARY_BUTTON_COLOR}
            onClick={() => setOpen(true)}
          >
            <InlineDiv className="centerDiv">
              <SemiBoldText fontSize="14px">
                {t("landing.explore_more")}
              </SemiBoldText>
              <Image
                src={ArrowRight.src}
                alt="Arrow Right"
                width={18}
                height={18}
                style={{ width: "18px", height: "18px", marginTop: "3px" }}
              />
            </InlineDiv>
          </CustomButton>
        </CustomDiv>
      </InlineDiv>
      <InlineDiv
        ref={element}
        className={"activityCarousel"}
        style={{
          gap: "16px",
          overflowX: "auto",
          marginTop: "30px",
        }}
      >
        <Image
          src={AventuraAcuatica}
          alt="Aventura Acuática"
          style={{ height: "300px", textAlign: "center", cursor: "pointer" }}
          onClick={() => {
            saveCategory("41");
            setOpen(true);
          }}
        />
        <Image
          src={AventuraAire}
          alt="Aventura en el aire"
          style={{ height: "300px", textAlign: "center", cursor: "pointer" }}
          onClick={() => {
            saveCategory(imInProd ? "42" : "43");
            setOpen(true);
          }}
        />
        <Image
          src={AventuraTierra}
          alt="Aventura en tierra"
          style={{ height: "300px", textAlign: "center", cursor: "pointer" }}
          onClick={() => {
            saveCategory(imInProd ? "43" : "42");
            setOpen(true);
          }}
        />
        <Image
          src={Bienestar}
          alt="Bienestar"
          style={{ height: "300px", textAlign: "center", cursor: "pointer" }}
          onClick={() => {
            saveCategory("4");
            setOpen(true);
          }}
        />
        <Image
          src={Bodegas}
          alt="Bodegas"
          style={{ height: "300px", textAlign: "center", cursor: "pointer" }}
          onClick={() => {
            saveCategory("44");
            setOpen(true);
          }}
        />
        <Image
          src={Cultura}
          alt="Cultura"
          style={{ height: "300px", textAlign: "center", cursor: "pointer" }}
          onClick={() => {
            saveCategory("2");
            setOpen(true);
          }}
        />
        <Image
          src={Deporte}
          alt="Deporte"
          style={{ height: "300px", textAlign: "center", cursor: "pointer" }}
          onClick={() => {
            saveCategory("5");
            setOpen(true);
          }}
        />
        <Image
          src={Entradas}
          alt="Entradas"
          style={{ height: "300px", textAlign: "center", cursor: "pointer" }}
          onClick={() => {
            saveCategory("9");
            setOpen(true);
          }}
        />
        <Image
          src={Fotografia}
          alt="Fotografía"
          style={{ height: "300px", textAlign: "center", cursor: "pointer" }}
          onClick={() => {
            saveCategory("7");
            setOpen(true);
          }}
        />
        <Image
          src={Gastronomia}
          alt="Gastronomía"
          style={{ height: "300px", textAlign: "center", cursor: "pointer" }}
          onClick={() => {
            saveCategory("3");
            setOpen(true);
          }}
        />
        <Image
          src={Naturaleza}
          alt="Naturaleza"
          style={{ height: "300px", textAlign: "center", cursor: "pointer" }}
          onClick={() => {
            saveCategory(imInProd ? "46" : "47");
            setOpen(true);
          }}
        />
        <Image
          src={Ocio}
          alt="Ocio"
          style={{ height: "300px", textAlign: "center", cursor: "pointer" }}
          onClick={() => {
            saveCategory(imInProd ? "47" : "45");
            setOpen(true);
          }}
        />
        <Image
          src={Talleres}
          alt="Talleres"
          style={{ height: "300px", textAlign: "center", cursor: "pointer" }}
          onClick={() => {
            saveCategory("10");
            setOpen(true);
          }}
        />
        {/* <Image
          src={Verano}
          alt="Verano"
          style={{ height: "300px", textAlign: "center", cursor: "pointer" }; setOpen(true)}}
        /> */}
      </InlineDiv>
      {showLeftArrow && (
        <VerticalCenterDiv left="20px">
          <CircularDiv
            background={PRIMARY_BUTTON_COLOR}
            width="56px"
            height="56px"
            paddingX="11px"
            className="carousel-button-category"
            onClick={() => {
              scrollBy({ left: -SCROLL_WIDTH, behavior: "smooth" });
            }}
          >
            <Image
              width={12}
              height={19}
              src={arrowRight}
              style={{ rotate: "180deg", width: "12px", height: "19px" }}
              alt="arrowRight"
            />
          </CircularDiv>
        </VerticalCenterDiv>
      )}
      {showRightArrow && (
        <VerticalCenterDiv right="20px">
          <CircularDiv
            background={PRIMARY_BUTTON_COLOR}
            width="56px"
            height="56px"
            paddingX="11px"
            className="carousel-button-category"
            onClick={() => {
              scrollBy({ left: SCROLL_WIDTH, behavior: "smooth" });
            }}
          >
            <Image
              width={12}
              height={19}
              src={arrowRight}
              alt="arrowRight"
              style={{ width: "12px", height: "19px" }}
            />
          </CircularDiv>
        </VerticalCenterDiv>
      )}
    </CustomDiv>
  );
};

export default Categories;
